import React from 'react';
import ModalDialog from './ModalDialog';

export function ItemRanOutOfStockDialog({
    visible,
    hasHotels,
    onClick: onClose,
}) {
    const title = !hasHotels
        ? 'Biljetterna har tagit slut'
        : 'Hotellet har blivit fullbokat';
    const text = !hasHotels
        ? 'Tyvärr har dina valda biljetter precis tagit slut. Vänligen börja om med er bokning.'
        : 'Tyvärr har ditt valda hotell precis tagit slut det önskade datumet. Vänligen börja om med er bokning.';

    return (
        <ModalDialog
            visible={visible}
            primaryAction={onClose}
            type="exclamation"
            modalHeader={title}
            modalBody={text}
            ctaButtonText="Påbörja ny bokning"
        />
    );
}
